import { ADD_COLLABORATOR_CARD_KEY } from '../../../../../../shared/constants/workspaceOnboarding';

/*
  ## Shared Library Onboarding Configuration

  * The `cards` array accepts `{ [CARD_KEY]: CONFIG_OBJECT }` as inputs, as well as arrays of
  `[ { [CARD_KEY1]: {...} }, { [CARD_KEY2]: {...} } ]` in case `type` is set to sequential.

  * Each card has these options available:
    > `dismissable` (Boolean)   // Allow card to be marked as complete and dismissed
    > `filter`      (Function)  // Function to define wheter the card will be displayed or not.
                                // Should return `true` for visible and `false` for hidden.
                                // This only evaluates if the card has not been dismissed yet.
    > `onComplete`  (Function)  // Callback function executed when a card is marked as complete.
    > `onDismiss`   (Function)  // Callback function executed when a card is dismissed.

  * This configuration file does not require the addition of SHARED_LIBRARY_INTRO_CARD,
  which is included to the onboarding carousel by default at utilities/getSharedLibraryCards.
*/
export const getSharedLibraryCardsConfig = () => {
  return {
    cards: [
      {
        [ADD_COLLABORATOR_CARD_KEY]: {
          dismissable: true,
          filter: () => true,
        },
      },
    ],
  };
};
